export type TaskRowMetadata = "conflict" | "blocked" | "priority" | "due" | "assignee" | "collection" | "completed" | "comments" | "subtasks" | "recurrence" | "tags" | "match";

export interface TaskRowContext {
  filter: string;
  grouping: string;
  collectionSelected: boolean;
  hasConflict: boolean;
  blocked: boolean;
  priority: "none" | "low" | "medium" | "high" | "urgent";
  hasDueDate: boolean;
  hasAssignees: boolean;
  hasCollection: boolean;
  completed: boolean;
  hasComments: boolean;
  hasSubtasks: boolean;
  recurring: boolean;
  hasTags: boolean;
  hiddenSearchMatch: boolean;
}

export function taskRowMetadata(context: TaskRowContext): TaskRowMetadata[] {
  const result: TaskRowMetadata[] = [];
  if (context.hasConflict) result.push("conflict");
  if (context.blocked) result.push("blocked");
  if (context.priority !== "none") result.push("priority");
  if (context.hasDueDate && context.filter !== "today") result.push("due");
  if (context.hasAssignees && context.filter !== "assigned" && context.grouping !== "assignee") result.push("assignee");
  if (context.hasCollection && !context.collectionSelected && context.grouping !== "subcategory") result.push("collection");
  if (context.completed && context.filter === "completed") result.push("completed");
  if (context.hasComments) result.push("comments");
  if (context.hasSubtasks) result.push("subtasks");
  if (context.recurring) result.push("recurrence");
  if (context.hasTags && context.grouping !== "tag") result.push("tags");
  if (context.hiddenSearchMatch) result.push("match");
  return result;
}
